import {AuthoringStandardSetModelV1} from 'resources/GeneratedModels/AuthoringStandardSet/AuthoringStandardSetModel.v1';

import {standardSetModelValidators} from '../StandardSet/StandardSetModel.v1.validators';

AuthoringStandardSetModelV1.addValidators(standardSetModelValidators);

export {AuthoringStandardSetModelV1};
